import { useEffect } from 'react';

export function useIframeHeight() {
  useEffect(() => {
    let lastHeight = 0;
    let debounceTimer = null;

    const sendHeight = () => {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        const height = Math.max(
          document.body.scrollHeight,
          document.documentElement.scrollHeight
        );
        if (height !== lastHeight) {
          lastHeight = height;
          window.parent.postMessage(height, '*');
        }
      }, 50);
    };

    // Send immediately on mount
    sendHeight();

    window.addEventListener('load', sendHeight);

    const mutationObserver = new MutationObserver(sendHeight);
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    return () => {
      if (debounceTimer) clearTimeout(debounceTimer);
      window.removeEventListener('load', sendHeight);
      mutationObserver.disconnect();
    };
  }, []);
}
